import { Mapper } from "lib/api"
import { ImpactedPlantDTO, ImpactedPlantDTOInner, Plant, ImpactedPlant } from "models"

// first param is the DTO, second param is the class
export class ImpactedPlantMapper extends Mapper<
	ImpactedPlantDTO | ImpactedPlantDTOInner,
	ImpactedPlant
> {
	constructor() {
		super(Plant) // Pass the target class constructor
	}
}

export function New(): ImpactedPlantMapper {
	return new ImpactedPlantMapper()
}
